import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormDropdownBlock as Block } from "./FormDropdownBlock";
import { defaultData } from "./FormDropdownBlockDefaultData";
import { meta } from "./FormDropdownBlockMetaData";

export const FormDropdownBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-dropdown",
    size: 24,
  },
  meta,
};
